import React from 'react';

import { Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import history from './services/history';

import Discontinued from './pages/Discontinued';

import GlobalStyle from './styles/global';

/**
 * The legacy Pagar.me v4 sales page is closed (DEV-1062): every route renders
 * the notice, and nothing here reaches the API any more.
 *
 * The old screens (Home, Subscribe, Success, BoletoPage, NotFound, Disabled)
 * are still in the repo but no longer imported, so they leave the bundle while
 * staying easy to restore.
 *
 * `ThemeProvider` is gone with them. It fetched `pageinfo/unidade/:id` to paint
 * the coach's background, which is one API call this page has no reason to
 * make. `GlobalStyle` still reads `theme.background.url`, so a static theme
 * takes its place — without it styled-components hands the template an empty
 * theme and the interpolation throws.
 */
const theme = { background: { url: '' } };

export default function Routes() {
  return (
    <Router history={history}>
      <StyledComponentsThemeProvider theme={theme}>
        <Switch>
          <Route path="/" component={Discontinued} />
        </Switch>

        <GlobalStyle />
      </StyledComponentsThemeProvider>
    </Router>
  );
}
